<h6 *ngIf="creatorstage == 'stagedisplay' && !viewtypeshort" class="text-dark font-weight-light cursor-default"
    style="margin-left: 10px; vertical-align: top; line-height: 20px;">{{person.fullname}}</h6>

<h6 *ngIf="spacing" class="text-dark font-weight-light cursor-default mb-0">{{person.fullname}}</h6>

<h6 *ngIf="viewtypeshort" class="text-dark font-weight-light cursor-default">{{person.fullname}}</h6>

<h6 *ngIf="chatType && creatorstage == '' && !viewtypeshort" class="text-dark font-weight-light cursor-default">
    {{person.fullname}}</h6>

<p *ngIf="viewtypeportal && widthpne != null" [ngStyle]="pnestyle"
    class="box text-dark font-weight-light mb-0 mr-2 text-truncate cursor-default align-middle lh-35">
    {{person.fullname}}</p>

<div *ngIf="!chatType && creatorstage == '' && !spacing" class="hover-card">
    <p class="text-light font-weight-light cursor-pointer" (click)="toggleCard()">{{person.fullname}}</p>
    <!---<div class="card hover-card-content p-2" *ngIf="show">
        <div class="row">
            <div class="col-auto">
                <app-personimage [personId]="person.personId"></app-personimage>
            </div>
            <div class="col-auto pl-0">
                <h6 class="text-dark pb-0 mb-0 font-weight-bold">{{person.fullname}}</h6>
                <p class="text-dark font-weight-light mb-0">{{person.email}}</p>
                <p class="text-dark font-weight-light mb-0">{{person.phone}}</p>
                <p class="text-dark font-weight-light mb-1">{{person.im}}</p>
            </div>
            <div class="col"></div>
            <div  (click)="toggleCard()" class="col-">
                <h6 matTooltip="{{ 'personname.closetip' | trans }}" matTooltipPosition="above"><span class="material-icons action-icon">
                    {{ 'personname.close' | trans }}
                </span></h6>
                VIEW PERSON MODAL EXPAND
                <h6 matTooltip="Click To Expand" matTooltipPosition="above"><span class="material-icons action-close">
                    open_in_full
                    </span></h6>
            </div>
        </div>
    </div>-->
</div>